module.exports = __webpack_public_path__ + "explore/images/eoy/bathtub.f4496bd7423557c02f1c60df3417fec7.png";